module.exports = __webpack_public_path__ + "static/media/janio_logo.9f7b0611.webp";